import blink from './blink.sb3';
import servoLoop from './servo_loop.sb3';
import servoEasing from './servo_easing.sb3';
import touchServo from './touch_servo.sb3';
import ultrasonicServo from './ultrasonic_servo.sb3';
import soundServo from './sound_servo.sb3';

const examples = [
    {
        id: 'blink',
        name: {
            'ja': 'LED',
            'ja-Hira': 'LED',
            'en': 'LED'
        },
        file: blink
    },
    {
        id: 'servo_loop',
        name: {
            'ja': 'サーボモーター',
            'ja-Hira': 'サーボモーター',
            'en': 'servo motor'
        },
        file: servoLoop
    },
    {
        id: 'servo_easing',
        name: {
            'ja': 'ゆっくりサーボモーターを動かす',
            'ja-Hira': 'ゆっくりサーボモーターをうごかす',
            'en': 'move servo motor slowly'
        },
        file: servoEasing
    },
    {
        id: 'touch',
        name: {
            'ja': 'タッチセンサー',
            'ja-Hira': 'タッチセンサー',
            'en': 'touch sensor'
        },
        file: touchServo
    },
    {
        id: 'distance',
        name: {
            'ja': '超音波センサー',
            'ja-Hira': 'ちょうおんぱセンサー',
            'en': 'ultrasonic sensor'
        },
        file: ultrasonicServo
    },
    {
        id: 'sound',
        name: {
            'ja': '音センサー',
            'ja-Hira': 'おとセンサー',
            'en': 'sound sensor'
        },
        file: soundServo
    }
];

export default examples;
